import { Howl, HowlOptions } from 'howler'
import { useEffect, useRef, useState } from 'react'

type Props = Record<string, unknown>

export const useHowler = (props: Props & HowlOptions) => {
  const audio = useRef<Howl | null>(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!props.src || (Array.isArray(props.src) && props.src.length === 0)) {
      return
    }

    audio.current = new Howl({ ...props })
    setReady(true)

    return () => {
      audio.current?.unload()
      audio.current = null
      setReady(false)
    }
  }, [props.src])

  return { audio: ready ? audio.current : null }
}
